<template>

<core-modal v-on:close="onClose" :icon="(data.manage || data.family) ? 'caret-left' : false">

	<template v-slot:head>

		<template v-if="data.family">Create Family Tag</template>
		<template v-if="!data.family">Create Tag</template>

	</template>

	<template v-slot:default>

		<core-form-input-textbox :autofocus="true" maxlength="16" name="text" v-on:validate="validate" placeholder="Enter tag" v-model="inputs.text" notes="Maximum of 16 characters." :error="is.error" :disabled="is.loading" :validation="validation.text" />

		<core-form-input-colourpicker title="Background" name="colour" v-on:validate="validate" v-model="inputs.colour" :error="is.error" :disabled="is.loading" :validation="validation.colour" v-if="needStyle" />

		<core-form-input-colourpicker title="Text" name="fore" v-on:validate="validate" v-model="inputs.fore" :error="is.error" :disabled="is.loading" :validation="validation.fore" :is-text="true" v-if="needStyle" />

		<core-form-input-togglelist title="Seen by" name="public" v-on:validate="validate" v-model="inputs.public" :error="is.error" :disabled="is.loading" :validation="validation.public" :options="publicOptions" v-if="!isFamily" />

		<core-form-input-togglelist title="Attaches to" name="context" v-on:validate="validate" v-model="inputs.context" :error="is.error" :disabled="is.loading" :validation="validation.context" :options="contextOptions" v-if="!isFamily" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!is.valid">Confirm</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	props: ['data'],
	
	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			inputs: {
				text: '',
				family: 0,
				public: 1,
				context: 0,
				colour: '#134677',
				fore: '#ffffff'
			},

			validation: {
				text: {
					exists: true,
					max: 16
				}
			}

		}

	},

	created: function() {

		this.inputs.family = this.data.family || 0

	},

	computed: {

        family: function() {

            return (this.isFamily) ? this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.data.family

            }.bind(this)) : false

        },

		isFamily: function() {

			return this.inputs.family

		},

		needStyle: function() {

			return !this.isFamily || !this.family.style

		},

		publicOptions: function() {

			return [{
				value: 1,
				title: 'Everyone',
				text: 'Anyone viewing your profile can see this tag and filter with it.'
			}, {
				value: 0,
				title: 'Only me',
				text: 'Only you can see this tag and filter with it.'
			}]

		},

		contextOptions: function() {

			var game = {
				value: this.$CONSTANTS.TAG.CONTEXT.GAME,
				title: 'Game',
				text: 'The tag is associated with the game and will be shown whenever the game appears in your profile.'
			}

			var collection = {
				value: this.$CONSTANTS.TAG.CONTEXT.COLLECTION,
				title: 'Collection',
				text: 'The tag is associated with this specific collection entry and will not appear elsewhere.'
			}

			var rating = {
				value: this.$CONSTANTS.TAG.CONTEXT.RATING,
				title: 'Rating',
				text: 'The tag is associated with this specific rating entry and will not appear elsewhere.'
			}

			var play = {
				value: this.$CONSTANTS.TAG.CONTEXT.PLAY,
				title: 'Play',
				text: 'The tag is associated with this specific play entry and will not appear elsewhere.'
			}

			if (this.data.filter === 'collection') return [game, collection]
			if (this.data.filter === 'ratings')    return [game, rating]
			if (this.data.filter === 'plays')      return [game, play]

			return [game, collection, rating, play]

		}

	},

	methods: {

		onConfirmClick: function() {

			if (this.is.valid) {

				this.is.loading = true

				this.$store.dispatch('api/tags/create', {
					data: this.inputs
				}).then(function(tag) {

					this.$store.commit('data/tags/add', [tag])

					if (this.data.gameIndex && this.data.itemIndex) {

						this.add(tag)

					} else {

						this.onClose()

					}

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this)) 

			}

		},

		add: function(tag) {

			this.$store.dispatch('api/tags/add', {
				tag: tag.id,
				index: (tag.context === this.$CONSTANTS.TAG.CONTEXT.GAME) ? this.data.gameIndex : this.data.itemIndex
			}).then(function(json) {

				this.$store.commit('page/' + this.data.filter + '/tags/add', {
					index: json.index,
					context: tag.context,
					tag: tag.id
				})

				this.onClose()

			}.bind(this), function() {

				this.onClose()

			}.bind(this)) 

		},

		onClose: function() {

			this.$emit('close')

			if (this.data.family) {

				this.$pubsub.$emit('open.modal', {
					id: 'tagFamilyManage',
					family: this.data.family
				})

			} else if (this.data.manage) {

				this.$pubsub.$emit('open.modal', 'tagManage')

			}	

		}

	}

}

</script>

<style scoped>

</style>